<section class="host-access white-box py-3 mt-3">
  @if (isProfile) {
    <div class="host-access-title ml-3">
      Profile Account Access
    </div>
  } @else {
    <div class="host-access-title ml-3">
      Host Account Access
    </div>
  }

  <div class="host-access-row px-3 d-flex align-items-center justify-content-between py-3">
    <div class="host-access-container ">
      <div class="host-access-container-title">
        Password
      </div>
      <div class="host-access-container-text">
        ************************
      </div>
    </div>
    <button class="archive-button host-access-button justify-content-center" (click)="onChangePassword.emit()">Change
      Password
    </button>
  </div>
  @if (!isProfile) {
    <div class="host-access-row px-3 d-flex align-items-center justify-content-between pt-3">
      <div class="host-access-container">
        <div class="host-access-container-title">
          Account Deactivation
        </div>
        <div class="host-access-container-text">
          Veni Vidi Vici
        </div>
      </div>
      <button class="archive-button host-access-button justify-content-center" (click)="onDeactivate.emit()">Deactivate
        Account
      </button>
    </div>
  }
</section>
